import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { OrderSupportLayout } from "../OrderSupportLayout";

import styles from "./index.module.scss";

export const LoadupRequestSection = (
    props: Immutable<{ id: string; children: React.ReactNode }>,
): React.JSX.Element => {
    return (
        <OrderSupportLayout
            id={props.id}
            centered
            className={styles.loadupRequest}
        >
            <h1>{t`Mattress Pickup Request`}</h1>
            <div className={styles.loadupRequestBody}>{props.children}</div>
        </OrderSupportLayout>
    );
};
